import type { ListViewItemCellProps } from './list-view-item-cell.types.ts';
import styles from './list-view-item-cell.module.scss';

export function ListViewItemCell({ children, className, flex = 1 }: ListViewItemCellProps) {
  return (
    <div className={`${styles.cell} ${className}`} style={{ flex: flex }}>
      {children}
    </div>
  );
}
